// extracted by mini-css-extract-plugin
export default {"productcard":"JH","productimage":"KH","username":"LH","multiBagName":"MH","productinfo":"NH","productinfoinner":"OH","productname":"PH","productsubheader":"QH","productdescription":"RH","productnumbers":"SH","productnumberstitle":"TH","productnumbersitem":"UH","number":"VH","numbertext":"WH","tabs":"XH","benefitsblock":"YH","benefit":"ZH","benefitname":"aI","benefitdescription":"bI","ingredientsblock":"cI","tipsblock":"eI","mobileonly":"fI"};
    if(module.hot) {
      // 1713912566112
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  